import { Spin } from 'antd';
import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from './auth.store';

type AuthGuardProps = {
  children: ReactNode;
};

/**
 * 把受保护的路由包起来。
 * - status === 'unknown' → 初次自检还在跑（/auth/refresh 或 /auth/me）→ 显示 spin
 * - status === 'unauthenticated' → 跳 /login，并把当前 path 带在 state，登录后回跳
 * - status === 'authenticated' → 透传 children
 */
export function AuthGuard({ children }: AuthGuardProps) {
  const status = useAuthStore((s) => s.status);
  const location = useLocation();

  if (status === 'unknown') {
    return (
      <div style={{ display: 'flex', height: '100%', alignItems: 'center', justifyContent: 'center' }}>
        <Spin tip="正在检查登录态..." />
      </div>
    );
  }
  if (status === 'unauthenticated') {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  return <>{children}</>;
}
